import { useState, useEffect } from "react";
import {
  useUpdateUserMutation,
  useDeleteUserMutation,
  useGetUserOrganizacijeByJmbgQuery,
} from "./usersApiSlice";
import { useSelector } from "react-redux";
import { selectCurrentToken } from "../auth/authSlice";
import { useNavigate } from "react-router-dom";
import { TrashIcon } from "@heroicons/react/24/outline";
import SubscriptionModal from "./SubscriptionModal";
import { useGetAllMotivacijeQuery } from "../ciljevi/ciljeviApiSlice";
import { useGetIshraneNames_Query } from "../ishrana/ishranaApiSlice";
import {
  PencilSquareIcon,
  EyeIcon,
  ArrowDownTrayIcon,
  UserIcon,
} from "@heroicons/react/20/solid";

// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faSave, faTrashCan } from "@fortawesome/free-solid-svg-icons";
// import { ROLES } from "../../config/roles";
// import Usp from "./Usp";
// import { Callout } from "@tremor/react";

// import NewPozicijaUOrganizacijiForm from "./dodavanjePozicijeOrganizaciji/NewPozicijaUOrganizacijiForm";
// import UserModalNewPozicija from "./dodavanjePozicijeOrganizaciji/UserModalNewPozicija";

//NEW
const tabs = [
  { name: "Osnovni podaci", href: "#Osnovni podaci" },
  { name: "Ciljevi", href: "#Ciljevi" },
  { name: "Fizicki parametri", href: "#Fizicki parametri" },
  { name: "Ishrana", href: "#Ishrana" },
  { name: "Namirnice", href: "#Namirnice" },
  { name: "Panovi ishrane", href: "#Panovi ishrane" },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const EditUserProfileForm = ({ user, index }) => {
  // useEffect(() => {
  //   console.log("USer -> ", user);
  // }, [user]);
  //User data
  const [id, setId] = useState(user._id);

  //Osnovni podaci
  const [name, setName] = useState(user.name);
  const [lastName, setLastName] = useState(user.lastName);
  const [tezina, setTezina] = useState(user.tezina);
  const [visina, setVisina] = useState(user.visina);
  const [mail, setMail] = useState(user.mail);
  const [pol, setPol] = useState(user.pol);
  const [telefon, setTelefon] = useState(user.telefon);
  const [godine, setGodine] = useState(user.datumRodjenja);

  //Ciljevi
  const [primCilj, setPrimCilj] = useState(user.primcilj);
  const [motiv, setMotiv] = useState(user.motiv);
  const [komCilja, setKomCilja] = useState(user.komCilja);

  //Fizicki parametri work here
  const [bloodType, setBloodType] = useState(user?.krvGru);
  const [activityLevel, setActivityLevel] = useState(user?.nivoAkt);
  const [struka, setStruka] = useState(user?.struk);
  const [kukova, setKukova] = useState(user?.kuk);
  const [vrat, setvrat] = useState(user?.vrat);
  const [alergije, setAlergije] = useState(user?.alergije);
  const [selectedActivities, setSelectedActivities] = useState(user?.vrstaFiz);
  const [imunitet, setImunitet] = useState(user?.imunitet);

  //Ishrana
  const [allergyChoice, setAllergyChoice] = useState(user?.allergyChoice);
  const [allergiesEnabled, setAllergiesEnabled] = useState(
    user?.allergiesEnabled
  );
  const [smoking, setSmoking] = useState(user?.pus);
  const [alkohol, setAlkohol] = useState(user?.alk);
  const [selectedIshrana, setSelectedIshrana] = useState(user?.selectedIshrana);
  const [ucestObr, setUcestObr] = useState(user?.ucestBr);
  const [navike, setNavike] = useState(user?.navikeUish);
  const [iskSaDijetama, setIskSaDijetama] = useState(user?.iskSaDijetama);

  //Namirnice
  const [voljeneNamirnice, setVoljeneNamirnice] = useState(
    user?.voljeneNamirnice
  );
  const [neVoljeneNamirnice, setNeVoljeneNamirnice] = useState(
    user?.neVoljeneNamirnice
  );

  //Panovi ishrane
  const [allImage, setAllImage] = useState(null);

  const [komentar, setKomentar] = useState(user.komentar);

  //ZA TABOVE
  const [currentTab, setCurrentTab] = useState(tabs[0].name);

  const token = useSelector(selectCurrentToken);

  const [aktivan, setAktivan] = useState(null); //Za jedan aktivan
  const [neAktivni, setNeAktivni] = useState(null); //Za jedan aktivan
  const [sviPaketi, setSviPaketi] = useState(null); //Za sve pakete
  const [addNewPretplataModal, setAddNewPretplataModal] = useState(false); //Modal za dodavanje nove pretplate

  const [isPopupOpen, setPopupOpen] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [idIzv, setIdIzv] = useState();

  const [availableMotivi, setAvailableMotivi] = useState();
  const [availableIshrane, setAvailableIshrane] = useState();

  //Modal
  //   const [isModalOpen, setIsModalOpen] = useState(false);

  //Modal dodaj poziciju OVDE IMPLEMENTIRAJ
  //   const [isModalPozicijaOpen, setIsModalPozicijaOpen] = useState(false);

  //   const handleOpenPozicijaModal = () => {
  //     setIsModalPozicijaOpen(true);
  //   };

  //   const handleClosePozicijaModal = () => {
  //     setIsModalPozicijaOpen(false);
  //   };

  //   const handleFormPozicijaSubmit = () => {
  //     handleClosePozicijaModal();
  //   };

  //   //Tabovi
  const handleTabClick = (tabName) => {
    setCurrentTab(tabName);
  };

  const handleSelectChange = (event) => {
    setCurrentTab(event.target.value);
  };

  const handleChange = (event) => {
    setKomentar(event.target.value);
  };

  const navigate = useNavigate();

  const dash = () => navigate(`/dash`);
  const userLista = () => navigate(`/dash/users`);

  const [updateUser, { isLoading, isSuccess, isError, error }] =
    useUpdateUserMutation();

  //Vaša motivacija,
  let returnName = (idMotiv) => {
    if (!Array.isArray(availableMotivi)) {
      console.error("Error: 'lista' nije definisana.");
      return "";
    }

    let match = availableMotivi.find((mot) => mot._id === idMotiv);
    return match ? match.naziv : "";
  };

  //Vasa ishrana name
  let returnIshranaName = (idIsh) => {
    if (!Array.isArray(availableIshrane)) {
      console.error("Error: 'lista' nije definisana.");
      return "";
    }

    let match = availableIshrane.find((ish) => ish._id === idIsh);
    return match ? match.naziv : "";
  };

  const [
    deleteUser,
    { isSuccess: isDelSuccess, isError: isDelError, error: delerror },
  ] = useDeleteUserMutation();

  const {
    isSuccess: isSuccessGetMotiv,
    isError: isErrorGetMotiv,
    error: getMotivError,
    data: getMotivData,
  } = useGetAllMotivacijeQuery();

  const {
    isSuccess: isSuccessGetIshName,
    isError: isErrorGetIshName,
    error: getIshNameError,
    data: getIshNameData,
  } = useGetIshraneNames_Query();

  //Uzimamo sve motive - OK
  useEffect(() => {
    if (isSuccessGetMotiv) {
      setAvailableMotivi(Object.values(getMotivData.entities || {}));
      // console.log("Avalibe motivi: ", Object.values(getMotivData.entities));
    }

    if (isErrorGetMotiv) {
      const errorMessage = getMotivError?.data?.message;
      alert(errorMessage);
    }
  }, [isSuccessGetMotiv, isErrorGetMotiv, getMotivError, getMotivData]);

  //Get Ishrana names - NIJE OK
  useEffect(() => {
    if (isSuccessGetIshName) {
      // Ispis odgovora iz API-ja u konzoli
      // console.log("Podaci o ishranama (getIshNameData):", getIshNameData);
      setAvailableIshrane(getIshNameData);
    }

    if (isErrorGetIshName) {
      const errorMessage = getIshNameError?.data?.message;
      alert(errorMessage);
    }
  }, [isSuccessGetIshName, isErrorGetIshName, getIshNameError, getIshNameData]);

  //HERE JMBG
  //   const {
  //     data: userPozicije,
  //     isSuccess: isSuccessUserPozicije,
  //     isLoading: isLoadingUserPozicije,
  //     isError: isErrorUserPozicije,
  //   } = useGetUserOrganizacijeByJmbgQuery(_jmbg);

  //HERE

  const getPdf = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/get-files/${id}`
      );
      const result = await response.json();
      setAllImage(result.data);
    } catch (error) {
      console.error("Greška prilikom učitavanja PDF datoteka:", error);
    }
  };

  const showPdf = (pdf) => {
    console.log("pdf => ", pdf);
    // setPdfFile(`${process.env.REACT_APP_API_URL}/files/${pdf}`); //Za localhost
    // setPdfFile(`https://nutritrans.rs/files/${pdf}`);
    const pdfUrl = `${process.env.REACT_APP_API_URL}/files/${pdf}`;
    window.open(pdfUrl, "_blank");
    // console.log(
    //   "SHOW PDF => ",
    //   `${process.env.REACT_APP_API_URL}/files/${pdf}`
    // );
    // setIsModalOpenPdf(true); // Open modal
  };

  useEffect(() => {
    if (currentTab === "Panovi ishrane") {
      getPdf();
    }
  }, [currentTab]);

  function izracunajGodine(datum) {
    // Kreiramo Date objekat za uneseni datum
    const datumObjekt = new Date(datum);

    // Dobijamo trenutnu godinu
    const trenutnaGodina = new Date().getFullYear();

    // Izračunavamo razliku između trenutne godine i godine iz datuma
    let godine = trenutnaGodina - datumObjekt.getFullYear();

    // Ako trenutni mesec još nije prošao u odnosu na mesec u datumu, oduzimamo još jednu godinu
    if (
      new Date().getMonth() < datumObjekt.getMonth() ||
      (new Date().getMonth() === datumObjekt.getMonth() &&
        new Date().getDate() < datumObjekt.getDate())
    ) {
      godine--;
    }

    return godine;
  }

  let tableContent = "";

  // const { ids,entities } = userPozicije

  //   if (isSuccessUserPozicije) {

  //     tableContent = userPozicije.ids.map((pozicijaId) => (
  //       <Usp key={pozicijaId} pozicijaId={pozicijaId} jmbg={_jmbg} />
  //     ));
  //   }

  //Setters
  const onNameChanged = (e) => setName(e.target.value);
  const onLastNameChanged = (e) => setLastName(e.target.value);
  const onTezinaChanged = (e) => setTezina(e.target.value);
  const onVisinaChanged = (e) => setVisina(e.target.value);
  const onTelefonChanged = (e) => setTelefon(e.target.value);
  const onMailChanged = (e) => setMail(e.target.value);
  const onPolChanged = (e) => setPol(e.target.value);

  //   const onRolesChanged = (e) => {
  //     const values = Array.from(
  //       e.target.selectedOptions,
  //       (option) => option.value
  //     );
  //     setRoles(values);
  //   };

  //   const onDeleteUserClicked = async () => {
  //     await deleteUser({ id: user.id });
  //   };

  //   const options = Object.values(ROLES).map((role) => {
  //     return (
  //       <option key={role} value={role}>
  //         {role}
  //       </option>
  //     );
  //   });

  const headers = new Headers();
  if (token) {
    headers.set("Authorization", `Bearer ${token}`); // Dodajemo Authorization token ako postoji
  }
  headers.set("Content-Type", "application/json");

  //- NE VIDI GA NA SERVERU...
  const sendKomentar = async () => {
    if (!komentar.trim()) {
      alert("Komentar ne može biti prazan!");
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/updateKomentar`,
        {
          method: "POST",
          headers: headers,
          body: JSON.stringify({
            id: id, // ID korisnika
            komentar: komentar,
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Došlo je do greške prilikom slanja komentara.");
      }

      const data = await response.json();
      console.log("Komentar je uspešno poslat:");

      alert("Komentar je uspešno poslat!");
    } catch (err) {
      console.error("Greška:", err);
      alert("Došlo je do greške prilikom slanja komentara.");
    }
  };

  const getPakete = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/get-pakete-sve/${id}`
      );
      const result = await response.json();
      let active = result.data.find((a) => a.status === "Aktivan"); //Uzimam poslednji u bazi koji je aktivan...
      let notactive = result.data.filter((a) => a.status === "Neaktivan");
      setAktivan(active);
      // setAllImage(notactive);
      setNeAktivni(notactive);

      setSviPaketi(result.data);
    } catch (error) {
      console.error("Greška prilikom učitavanja PDF datoteka:", error);
    }
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB").replace(/\//g, "/"); // YYYY/MM/DD
  }

  useEffect(() => {
    getPakete();
  }, []);

  let izbrisiPaket = (id) => {
    fetch(`${process.env.REACT_APP_API_URL}/delete-paket`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id: id }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          getPakete();
        } else {
          alert("Došlo je do greške prilikom brisanja paketa");
        }
      })
      .catch((error) => {
        console.error("Greška:", error);
      });
  };

  let addIzvestaji = (id, izv) => {
    setIdIzv(id); //idIzv
    setInputValue(izv);
    setPopupOpen(true);
  };

  const updateIzvestajFull = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/update-paket-izvestaji-full`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            idIzv,
            inputValue,
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Greška pri dodavanju paketa");
      }

      const result = await response.json();
      alert("Uspešno promenjen izvestaj");
      setPopupOpen(false);
      getPakete();
    } catch (error) {
      console.error("Greška prilikom dodavanja paketa:", error);
    }
  };

  //Osnovni podaci su ovo...
  const tailwindContent = (
    <div className="grid grid-cols-1 gap-x-8 gap-y-8 md:grid-cols-3">
      <form className="bg-white md:col-span-3">
        <div className="px-2 py-2 sm:p-2">
          {/* ZA GRID MAX-W-2XL */}
          <div className="grid max-w-full grid-cols-1 gap-x-4 gap-y-4 sm:grid-cols-6">
            {/* <div className="sm:col-span-1">
              <label
                htmlFor="last-name"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Redni Broj
              </label>
              <div className="mt-1">
                <input
                  readOnly
                  type="text"
                  name="rb"
                  id="rb"
                  value={index + 1}
                  autoComplete="rb"
                  className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div> */}
            <div className="sm:col-span-1">
              <label
                htmlFor="last-name"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Ime
              </label>
              <div className="mt-1">
                <input
                  readOnly
                  type="text"
                  name="last-name"
                  id="last-name"
                  value={name}
                  // onChange={onNameChanged}
                  autoComplete="family-name"
                  className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div className="sm:col-span-1">
              <label
                htmlFor="last-name"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Prezime
              </label>
              <div className="mt-1">
                <input
                  readOnly
                  type="text"
                  name="last-name"
                  id="last-name"
                  value={lastName}
                  // onChange={onLastNameChanged}
                  autoComplete="family-name"
                  className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div className="sm:col-span-1">
              <label
                htmlFor="street-mail"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Email
              </label>
              <div className="mt-1">
                <input
                  readOnly
                  type="text"
                  name="street-mail"
                  id="street-mail"
                  value={mail}
                  // onChange={onMailChanged}
                  autoComplete="street-mail"
                  className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div className="sm:col-span-1">
              <label
                htmlFor="pol"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Pol
              </label>
              <div className="mt-1">
                <input
                  readOnly
                  type="text"
                  name="pol"
                  id="pol"
                  value={pol}
                  // onChange={onPolChanged}
                  autoComplete="pol"
                  className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div className="sm:col-span-1">
              <label
                htmlFor="telefon"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Telefon
              </label>
              <div className="mt-1">
                <input
                  readOnly
                  type="text"
                  name="telefon"
                  id="telefon"
                  value={telefon}
                  // onChange={onTelefonChanged}
                  autoComplete="telefon"
                  className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div className="sm:col-span-1">
              <label
                htmlFor="telefon"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Visina
              </label>
              <div className="mt-1">
                <input
                  readOnly
                  type="text"
                  name="visina"
                  id="visina"
                  value={visina}
                  // onChange={onVisinaChanged}
                  autoComplete="visina"
                  className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div className="sm:col-span-1">
              <label
                htmlFor="telefon"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Tezina
              </label>
              <div className="mt-1">
                <input
                  readOnly
                  type="text"
                  name="tezina"
                  id="tezina"
                  value={tezina}
                  // onChange={onTezinaChanged}
                  autoComplete="tezina"
                  className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div className="sm:col-span-1">
              <label
                htmlFor="telefon"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Godine
              </label>
              <div className="mt-1">
                <input
                  disabled
                  type="text"
                  name="godine"
                  id="godine"
                  value={izracunajGodine(godine)}
                  autoComplete="tezina"
                  className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );

  let ciljevi = (
    <div className="grid grid-cols-1 gap-x-8 gap-y-8 md:grid-cols-1">
      <form className="bg-white md:col-span-3">
        <div className="px-2 py-2 sm:p-2">
          {/* ZA GRID MAX-W-2XL */}
          <div className="grid max-w-full grid-cols-1 gap-x-4 gap-y-4 sm:grid-cols-1">
            <div className="sm:col-span-1">
              <label
                htmlFor="primCilj"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Osnovni ciljevi
              </label>
              <div className="mt-1">
                <input
                  readOnly
                  type="text"
                  name="primCilj"
                  id="primCilj"
                  value={primCilj}
                  defaultValue={primCilj}
                  // onChange={onNameChanged}
                  autoComplete="primCilj"
                  className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div className="sm:col-span-1">
              <label
                htmlFor="motiv"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Vaša motivacija
              </label>
              <div className="mt-1">
                <input
                  readOnly
                  type="text"
                  name="motiv"
                  id="motiv"
                  value={returnName(motiv)}
                  // onChange={onLastNameChanged}
                  autoComplete="family-name"
                  className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div className="sm:col-span-1">
              <label
                htmlFor="last-name"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Dodatni komentar cilja
              </label>

              <textarea
                id="komCilja"
                value={komCilja}
                // onChange={handleChange}
                rows="7"
                className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );

  const nivoiFizickihAktivnosti = {
    sedentarni: {
      naziv: "Sedentaran",
      faktorAktivnosti: 1.2,
    },
    laganaAktivnost: {
      naziv: "Lagano aktivan",
      faktorAktivnosti: 1.375,
    },
    umerenaAktivnost: {
      naziv: "Umereno aktivan",
      faktorAktivnosti: 1.55,
    },
    intenzivnaAktivnost: {
      naziv: "Veoma aktivan",
      faktorAktivnosti: 1.725,
    },
    vrloIntenzivnaAktivnost: {
      naziv: "Ekstremno aktivan",
      faktorAktivnosti: 1.9,
    },
  };

  function getNivoFizickeAktivnosti(faktorAktivnosti) {
    if (typeof faktorAktivnosti === "string") {
      faktorAktivnosti = parseFloat(faktorAktivnosti);
    }
    for (let nivo in nivoiFizickihAktivnosti) {
      if (nivoiFizickihAktivnosti[nivo].faktorAktivnosti === faktorAktivnosti) {
        return nivoiFizickihAktivnosti[nivo].naziv;
      }
    }
    return "Nepoznat nivo aktivnosti"; // Ako faktor aktivnosti nije pronađen
  }

  let fizickiParam = (
    <div className="grid grid-cols-1 gap-x-8 gap-y-8 md:grid-cols-3">
      <form className="bg-white md:col-span-3">
        <div className="px-2 py-2 sm:p-2">
          {/* ZA GRID MAX-W-2XL */}
          <div className="grid max-w-full grid-cols-1 gap-x-4 gap-y-4 sm:grid-cols-6">
            <div className="sm:col-span-1">
              <label
                htmlFor="activityLevel"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Nivo aktivnosti
              </label>
              <div className="mt-1">
                <input
                  readOnly
                  type="text"
                  name="activityLevel"
                  id="activityLevel"
                  value={getNivoFizickeAktivnosti(activityLevel)}
                  // onChange={onNameChanged}
                  autoComplete="activityLevel"
                  className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div className="sm:col-span-1">
              <label
                htmlFor="alergije"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Alergije
              </label>
              <div className="mt-1">
                <input
                  readOnly
                  type="text"
                  name="alergije"
                  id="alergije"
                  value={alergije}
                  // onChange={onMailChanged}
                  autoComplete="alergije"
                  className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div className="sm:col-span-1">
              <label
                htmlFor="bloodType"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Krvna grupa
              </label>
              <div className="mt-1">
                <input
                  readOnly
                  type="text"
                  name="bloodType"
                  id="bloodType"
                  value={bloodType}
                  // onChange={onLastNameChanged}
                  autoComplete="bloodType"
                  className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div className="sm:col-span-1">
              <label
                htmlFor="struka"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Struk
              </label>
              <div className="mt-1">
                <input
                  readOnly
                  type="text"
                  name="struka"
                  id="struka"
                  value={struka}
                  // onChange={onTelefonChanged}
                  autoComplete="struka"
                  className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div className="sm:col-span-1">
              <label
                htmlFor="kukova"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Kuk
              </label>
              <div className="mt-1">
                <input
                  readOnly
                  type="text"
                  name="kukova"
                  id="kukova"
                  value={kukova}
                  // onChange={onVisinaChanged}
                  autoComplete="kukova"
                  className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div className="sm:col-span-1">
              <label
                htmlFor="kukova"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Vrat
              </label>
              <div className="mt-1">
                <input
                  readOnly
                  type="text"
                  name="kukova"
                  id="kukova"
                  value={vrat}
                  // onChange={onTezinaChanged}
                  autoComplete="kukova"
                  className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div className="sm:col-span-1">
              <label
                htmlFor="imunitet"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Jak imunitet
              </label>
              <div className="mt-1">
                <input
                  readOnly
                  type="text"
                  name="imunitet"
                  id="imunitet"
                  value={imunitet}
                  // onChange={onTezinaChanged}
                  autoComplete="imunitet"
                  className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            {/* 
            <div className="sm:col-span-1">
              <label
                htmlFor="telefon"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Godine
              </label>
              <div className="mt-1">
                <input
                  readOnly
                  type="text"
                  name="godine"
                  id="godine"
                  value={izracunajGodine(godine)}
                  autoComplete="tezina"
                  className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div> */}

            <div className="sm:col-span-5">
              <label
                htmlFor="aktivnosti"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Omiljene aktivnosti
              </label>
              <div className="mt-1">
                <input
                  readOnly
                  type="text"
                  name="aktivnosti"
                  id="aktivnosti"
                  value={selectedActivities?.join(", ") || ""}
                  // onChange={onPolChanged}
                  autoComplete="off"
                  className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );

  let ishrana = (
    <div className="grid grid-cols-1 gap-x-8 gap-y-8 md:grid-cols-3">
      <form className="bg-white md:col-span-3">
        <div className="px-2 py-2 sm:p-2">
          {/* ZA GRID MAX-W-2XL */}
          <div className="grid max-w-full grid-cols-1 gap-x-4 gap-y-4 sm:grid-cols-6">
            <div className="sm:col-span-1">
              <label
                htmlFor="selectedIshrana"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Vaš stil ishrane
              </label>
              <div className="mt-1">
                <input
                  readOnly
                  type="text"
                  name="selectedIshrana"
                  id="selectedIshrana"
                  value={returnIshranaName(selectedIshrana)}
                  // onChange={onNameChanged}
                  autoComplete="selectedIshrana"
                  className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div className="sm:col-span-1">
              <label
                htmlFor="ucestObr"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Broj obroka dnevno
              </label>
              <div className="mt-1">
                <input
                  readOnly
                  type="text"
                  name="ucestObr"
                  id="ucestObr"
                  value={ucestObr}
                  // onChange={onMailChanged}
                  autoComplete="ucestObr"
                  className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div className="sm:col-span-1">
              <label
                htmlFor="alkohol"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Konzumirate li alkohol?
              </label>
              <div className="mt-1">
                <input
                  readOnly
                  type="text"
                  name="alkohol"
                  id="alkohol"
                  value={alkohol}
                  // onChange={onLastNameChanged}
                  autoComplete="alkohol"
                  className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div className="sm:col-span-1">
              <label
                htmlFor="smoking"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Pušite li?
              </label>
              <div className="mt-1">
                <input
                  readOnly
                  type="text"
                  name="smoking"
                  id="smoking"
                  value={smoking}
                  // onChange={onTelefonChanged}
                  autoComplete="smoking"
                  className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div className="sm:col-span-1">
              <label
                htmlFor="allergiesEnabled"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Da li imate alergije na hranu?
              </label>
              <div className="mt-1">
                <input
                  readOnly
                  type="text"
                  name="allergiesEnabled"
                  id="allergiesEnabled"
                  value={allergiesEnabled}
                  // onChange={onVisinaChanged}
                  autoComplete="allergiesEnabled"
                  className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div className="sm:col-span-1">
              <label
                htmlFor="allergyChoice"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Da li ste alergični na neku namirnicu?
              </label>
              <div className="mt-1">
                <input
                  readOnly
                  type="text"
                  name="allergyChoice"
                  id="allergyChoice"
                  value={allergyChoice}
                  // onChange={onVisinaChanged}
                  autoComplete="allergyChoice"
                  className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div className="sm:col-span-6">
              <label
                htmlFor="navike"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Opis navika u ishrani
              </label>
              <div className="mt-1">
                <textarea
                  id="navike"
                  value={navike}
                  // onChange={handleChange}
                  rows="7"
                  className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>

            <div className="sm:col-span-6">
              <label
                htmlFor="iskSaDijetama"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Vaša iskustva sa dijetama
              </label>
              <div className="mt-1">
                <textarea
                  id="iskSaDijetama"
                  value={iskSaDijetama}
                  // onChange={handleChange}
                  rows="7"
                  className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );

  let naminice = (
    <div className="grid grid-cols-1 gap-x-8 gap-y-8 md:grid-cols-3">
      <form className="bg-white md:col-span-3">
        <div className="px-2 py-2 sm:p-2">
          {/* ZA GRID MAX-W-2XL */}
          <div className="grid max-w-full grid-cols-1 gap-x-4 gap-y-4 sm:grid-cols-6">
            <div className="sm:col-span-6">
              <label
                htmlFor="voljeneNamirnice"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Omiljene namirnice (odvojite ih zarezom)
              </label>
              <div className="mt-1">
                <input
                  readOnly
                  type="text"
                  name="voljeneNamirnice"
                  id="voljeneNamirnice"
                  value={voljeneNamirnice}
                  // onChange={onNameChanged}
                  autoComplete="voljeneNamirnice"
                  className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div className="sm:col-span-6">
              <label
                htmlFor="neVoljeneNamirnice"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Namirnice koje izbegavate (odvojite ih zarezom)
              </label>
              <div className="mt-1">
                <input
                  readOnly
                  type="text"
                  name="neVoljeneNamirnice"
                  id="neVoljeneNamirnice"
                  value={neVoljeneNamirnice}
                  // onChange={onMailChanged}
                  autoComplete="neVoljeneNamirnice"
                  className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            {/* Dodaj ovde naminice */}
            {/* <div className="my-4">
                                    <div className="flex items-center space-x-1 mb-2">
                                      <h3 className="text-xl font-semibold mb-0">
                                        Spisak dostupnih namirnica
                                      </h3>
                                      <Tooltip text="Pregledajte dostupne namirnice i prilagodite svoj izbor." />
                                    </div>
            
                                    <div
                                      className="bg-green-100 overflow-y-scroll"
                                      style={{ maxHeight: "400px" }}
                                    >
                                      {Object.keys(grupisaneNamirnice).map((grupa) => (
                                        <div key={grupa} className="mb-4">
                                          <h3 className="text-lg font-semibold">{grupa}</h3>
                                          {Object.keys(grupisaneNamirnice[grupa]).map(
                                            (podtip) => (
                                              <div key={podtip} className="ml-4 mb-2">
                                                <h4 className="text-md font-medium">
                                                  {podtip}
                                                </h4>
                                                <div className="ml-6">
                                                  {grupisaneNamirnice[grupa][podtip].map(
                                                    (namirnica) => (
                                                      <div
                                                        key={namirnica._id}
                                                        className="flex items-center mb-1"
                                                      >
                                                        <input
                                                          type="checkbox"
                                                          value={namirnica._id}
                                                          checked={odabraneNamirnice?.includes(
                                                            namirnica._id
                                                          )}
                                                          onChange={handleNamirnicaChange}
                                                          className="mr-2"
                                                          disabled={
                                                            disabledNamirnice.includes(
                                                              namirnica._id
                                                            ) ||
                                                            !ishrane
                                                              .find(
                                                                (ishrana) =>
                                                                  ishrana._id ===
                                                                  selectedIshrana
                                                              )
                                                              ?.namirnice.includes(
                                                                namirnica._id
                                                              )
                                                          } // Disable checkbox ako namirnica nije deo izabrane ishrane ili cilja
                                                        />
                                                        <label>
                                                          {namirnica.naziv}{" "}
                                                          {namirnica.alergen
                                                            ? "(Alergen)"
                                                            : namirnica.gluten
                                                            ? "(Sadrži Gluten)"
                                                            : namirnica.laktoza
                                                            ? "(Sadrži Laktozu)"
                                                            : ""}
                                                        </label>
                                                      </div>
                                                    )
                                                  )}
                                                </div>
                                              </div>
                                            )
                                          )}
                                        </div>
                                      ))}
                                    </div>
                                  </div> */}
          </div>
        </div>
      </form>
    </div>
  );

  let panoviIshrane = (
    <div className="uploaded">
      {allImage && allImage.length > 0 ? (
        <div className="overflow-x-auto">
          <table className="min-w-full border-collapse border border-gray-300">
            <thead className="bg-gray-100">
              <tr>
                <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                  Datum kreiranja izveštaja
                </th>
                <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                  Primarni cilj
                </th>
                <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                  Datum početka ishrane
                </th>
                <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                  Datum završetka ishrane
                </th>
                <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                  Broj dana ishrane
                </th>
                <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                  Status
                </th>
                <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                  Akcije
                </th>
              </tr>
            </thead>
            {/*  */}
            <tbody className="bg-white">
              {allImage
                .slice()
                .reverse()
                .map((data) => (
                  <tr key={data._id}>
                    <td className="border-b border-r px-4 py-2 text-sm text-gray-900 whitespace-nowrap">
                      {data?.datumKreir} -{" "}
                      {data?.vreme ? data?.vreme.slice(0, 5) : ""}
                      {/*datumKreir - vreme  {data?.vreme ? data?.vreme.slice(0, 5) : ''}*/}
                    </td>
                    <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                      {data?.title} {/* primarni cilj */}
                    </td>
                    <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                      {data?.datumPoc} {/* dat poc */}
                    </td>
                    <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                      {data?.datumKraj} {/* dat kraja */}
                    </td>
                    <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                      {data?.tip} {/* tip */}
                    </td>
                    <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                      {data?.status} {/* status */}
                    </td>
                    <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                      <div className="flex items-center space-x-4">
                        <button
                          className="text-blue-600 hover:text-blue-800"
                          onClick={() => showPdf(data.pdf)} // Open PDF in popup
                        >
                          <EyeIcon className="h-5 w-5" aria-hidden="true" />
                        </button>
                        {/*<div className="border-l h-5" />
                       <button
                        className="text-blue-600 hover:text-blue-800"
                        onClick={() => downloadPdf(data.pdf)}
                      >
                        <ArrowDownTrayIcon
                          className="h-5 w-5"
                          aria-hidden="true"
                        />
                      </button>
                      <div className="border-l h-5" />
                      <button
                        onClick={() => preiewData(data)}
                        className="text-blue-600 hover:text-blue-800"
                      >
                        <UserIcon className="h-5 w-5" aria-hidden="true" />
                      </button>
                      <div className="border-l h-5" />
                      <button
                        className="text-red-600 hover:text-red-800"
                        onClick={() => deletePdf(data._id, data.pdf)}
                      >
                        <TrashIcon className="h-5 w-5" aria-hidden="true" />
                      </button> */}
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
          <br />
          {/* <br/> */}
        </div>
      ) : (
        <p>Nema otpremljenih izveštaja.</p>
      )}
    </div>
  );

  return (
    <>
      {/* template za svaku komponentu */}
      <div className="">
        <header className="mb-3">
          <div className="">
            <h1 className="text-3xl font-bold leading-tight tracking-tight text-gray-900">
              Klijent
            </h1>
          </div>
        </header>
        <hr className="border-t border-slate-950" />
        <main className="">
          <div className="">
            {/* <br/> */}
            {/* {tailwindContent} */}

            <br />
            <h3 className="text-gray-700">1. Podaci korisnikovog profila:</h3>

            <div className="bg-white shadow-sm ring-2 ring-gray-900/5 sm:rounded mt-3">
              <div className="sm:hidden">
                <label htmlFor="tabs" className="sr-only">
                  Select a tab
                </label>
                <select
                  id="tabs"
                  name="tabs"
                  className="block w-full rounded border-gray-300 focus:border-blue-500 focus:ring-blue-500"
                  value={currentTab}
                  onChange={handleSelectChange}
                >
                  {tabs.map((tab) => (
                    <option key={tab.name} value={tab.name}>
                      {tab.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="hidden sm:block">
                <nav
                  className="isolate flex divide-x divide-gray-200 rounded shadow"
                  aria-label="Tabs"
                >
                  {tabs.map((tab, tabIdx) => (
                    <a
                      key={tab.name}
                      href={tab.href}
                      onClick={(e) => {
                        e.preventDefault();
                        handleTabClick(tab.name);
                      }}
                      className={classNames(
                        tab.name === currentTab
                          ? "text-gray-900"
                          : "text-gray-500 hover:text-gray-700",
                        tabIdx === 0 ? "rounded-tl rounded-bl" : "",
                        tabIdx === tabs.length - 1
                          ? "rounded-tr rounded-br"
                          : "",
                        "group relative w-1/2 overflow-hidden bg-white px-4 py-4 text-center text-sm font-medium hover:bg-gray-50 focus:z-10"
                      )}
                      aria-current={
                        tab.name === currentTab ? "page" : undefined
                      }
                    >
                      <span>{tab.name}</span>
                      <span
                        aria-hidden="true"
                        className={classNames(
                          tab.name === currentTab
                            ? "bg-blue-500"
                            : "bg-transparent",
                          "absolute inset-x-0 bottom-0 h-0.5"
                        )}
                      />
                    </a>
                  ))}
                </nav>
              </div>

              <div className="">
                {currentTab === "Osnovni podaci" && (
                  <div className="block w-full rounded bg-white border-gray-300">
                    {tailwindContent}
                  </div>
                )}
                {currentTab === "Ciljevi" && (
                  <div className="block w-full rounded bg-white border-gray-300">
                    {ciljevi}
                  </div>
                )}
                {currentTab === "Fizicki parametri" && (
                  <div className="block w-full rounded bg-white border-gray-300">
                    {fizickiParam}
                  </div>
                )}
                {currentTab === "Ishrana" && (
                  <div className="block w-full rounded bg-white border-gray-300">
                    {ishrana}
                  </div>
                )}
                {currentTab === "Namirnice" && (
                  <div className="block w-full rounded bg-white border-gray-300">
                    {naminice}
                  </div>
                )}
                {currentTab === "Panovi ishrane" && (
                  <div className="block w-full h-max rounded bg-white border-gray-300">
                    {panoviIshrane}
                  </div>
                )}
              </div>
            </div>

            <br />

            <div className="mt-3 sm:flex sm:items-center">
              <div className="sm:flex-auto">
                <h3 className="text-gray-700">2. Komentar za korisnika:</h3>
              </div>

              <div className="mt-4 sm:ml-2 sm:mt-0 sm:flex-none">
                <button
                  onClick={sendKomentar}
                  className="rounded bg-blue-600 px-2 py-1 h-8 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                >
                  Dodaj komentar
                </button>
              </div>
            </div>

            <textarea
              id="komentar"
              value={komentar}
              onChange={handleChange}
              rows="4"
              className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 mt-2"
            />

            <br />
            <br />
            <div className="mt-3 sm:flex sm:items-center">
              <div className="sm:flex-auto">
                <h3 className="text-gray-700">3. Pretplate korisnika:</h3>
              </div>

              <div className="mt-4 sm:ml-2 sm:mt-0 sm:flex-none">
                {/* <button
                  // onClick={sendKomentar}
                  className="rounded bg-blue-600 px-2 py-1 h-8 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                >
                  Dodaj novu pretplatu
                </button> */}
                <SubscriptionModal id={id} mail={mail} />
              </div>
            </div>

            {/* Za sad su svi paketi prikazani */}
            {sviPaketi && sviPaketi.length > 0 ? (
              <div className="overflow-x-auto">
                <table className="min-w-full border-collapse border border-gray-300">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                        Order ID
                      </th>
                      <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                        Transakcioni ID
                      </th>
                      <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                        Naziv
                      </th>
                      <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                        Tip
                      </th>
                      <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                        Datum placanja
                      </th>
                      <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                        Datum isteka
                      </th>
                      <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                        Datum otkazivanja
                      </th>
                      <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                        Full izveštaj
                      </th>
                      <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                        Osnovni izveštaj
                      </th>
                      <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                        Cena
                      </th>
                      <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                        Valuta
                      </th>
                      <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                        Status
                      </th>
                      <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                        Akcije
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white">
                    {sviPaketi
                      .slice()
                      .reverse()
                      .map((data) => (
                        <tr key={data._id}>
                          <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                            {data?.orgderId ? data?.orgderId : "-"}
                          </td>
                          <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                            {data?.TransId ? data?.TransId : "-"}
                          </td>
                          <td className="border-b border-r px-4 py-2 text-sm text-gray-900 whitespace-nowrap">
                            {data?.naziv_paketa}
                          </td>
                          <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                            {data?.tip}
                          </td>
                          <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                            {formatDate(data?.datum_placanja)}
                          </td>
                          <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                            {formatDate(data?.datum_isteka)}
                          </td>
                          <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                            {data?.datum_otkazivanja
                              ? formatDate(data?.datum_otkazivanja)
                              : "Nije otkazano"}
                          </td>
                          <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                            {data?.broj?.full}
                          </td>
                          <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                            {data?.broj?.base}
                          </td>
                          <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                            {data?.cena}
                          </td>
                          <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                            {data?.valuta}
                          </td>
                          <td
                            className={`border-b border-r px-4 py-2 text-sm text-gray-900 ${
                              data?.status === "Neaktivan"
                                ? "bg-red-500"
                                : "bg-green-500"
                            }`}
                          >
                            {data?.status}
                          </td>

                          <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                            <div className="flex items-center space-x-4">
                              <button
                                className="text-red-600 hover:text-red-800"
                                onClick={() => izbrisiPaket(data._id)}
                              >
                                <TrashIcon
                                  className="h-5 w-5"
                                  aria-hidden="true"
                                />
                              </button>
                              <button
                                className="text-yellow-600 hover:text-yellow-800"
                                onClick={() =>
                                  addIzvestaji(data._id, data?.broj?.full)
                                }
                              >
                                <PencilSquareIcon
                                  className="h-5 w-5"
                                  aria-hidden="true"
                                />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
                <br />
                <br />
                <br />
              </div>
            ) : (
              <p>Nema otpremljenih paketa.</p>
            )}
          </div>

          {isPopupOpen && (
            <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50">
              <div className="bg-white p-6 rounded-lg shadow-lg w-80">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Izmeni broj izveštaja
                </label>
                <input
                  type="text"
                  value={inputValue}
                  onChange={(e) => setInputValue(e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                />
                <div className="mt-4 flex justify-end gap-2">
                  <button
                    className="px-4 py-2 text-sm bg-gray-300 rounded-md hover:bg-gray-400"
                    onClick={() => setPopupOpen(false)}
                  >
                    Ugasi
                  </button>
                  <button
                    className="px-4 py-2 text-sm bg-indigo-600 text-white rounded-md hover:bg-indigo-700"
                    onClick={() => updateIzvestajFull()}
                  >
                    Dodeli
                  </button>
                </div>
              </div>
            </div>
          )}
        </main>
      </div>

      {/* <UserModalNewPozicija
        isOpen={isModalPozicijaOpen}
        onClose={handleClosePozicijaModal}
      >
        <NewPozicijaUOrganizacijiForm
          onSubmit={handleFormPozicijaSubmit}
          onClose={handleClosePozicijaModal}
          jmbg={_jmbg}
        />
      </UserModalNewPozicija> */}
    </>
  );
};
export default EditUserProfileForm;

//Tabovi
{
  /* <div className="bg-white shadow-sm ring-2 ring-gray-900/5 sm:rounded mt-3">
              <div className="sm:hidden">
                <label htmlFor="tabs" className="sr-only">
                  Select a tab
                </label>
                <select
                  id="tabs"
                  name="tabs"
                  className="block w-full rounded border-gray-300 focus:border-blue-500 focus:ring-blue-500"
                  value={currentTab}
                  onChange={handleSelectChange}
                >
                  {tabs.map((tab) => (
                    <option key={tab.name} value={tab.name}>
                      {tab.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="hidden sm:block">
                <nav
                  className="isolate flex divide-x divide-gray-200 rounded shadow"
                  aria-label="Tabs"
                >
                  {tabs.map((tab, tabIdx) => (
                    <a
                      key={tab.name}
                      href={tab.href}
                      onClick={(e) => {
                        e.preventDefault();
                        handleTabClick(tab.name);
                      }}
                      className={classNames(
                        tab.name === currentTab
                          ? "text-gray-900"
                          : "text-gray-500 hover:text-gray-700",
                        tabIdx === 0 ? "rounded-tl rounded-bl" : "",
                        tabIdx === tabs.length - 1
                          ? "rounded-tr rounded-br"
                          : "",
                        "group relative w-1/2 overflow-hidden bg-white px-4 py-4 text-center text-sm font-medium hover:bg-gray-50 focus:z-10"
                      )}
                      aria-current={
                        tab.name === currentTab ? "page" : undefined
                      }
                    >
                      <span>{tab.name}</span>
                      <span
                        aria-hidden="true"
                        className={classNames(
                          tab.name === currentTab
                            ? "bg-blue-500"
                            : "bg-transparent",
                          "absolute inset-x-0 bottom-0 h-0.5"
                        )}
                      />
                    </a>
                  ))}
                </nav>
              </div>

           
              <div className="">
                {currentTab === "Obrčun" && (
                  <div className="block w-full h-100 rounded bg-white p-4 border-gray-300">
                    <h2 className="text-xl font-semibold text-gray-900">
                      Content for Tab 1
                    </h2>
                    <p className="mt-2 text-gray-700">
                      This is the section for Tab 1.
                    </p>
                  </div>
                )}
                {currentTab === "Akontacija" && (
                  <div className="block w-full h-72 rounded bg-white p-4 border-gray-300">
                    <h2 className="text-xl font-semibold text-gray-900">
                      Content for Tab 2
                    </h2>
                    <p className="mt-2 text-gray-700">
                      This is the section for Tab 2.
                    </p>
                  </div>
                )}
                {currentTab === "Krediti" && (
                  <div className="block w-full h-80 rounded bg-white p-4 border-gray-300">
                    <h2 className="text-xl font-semibold text-gray-900">
                      Content for Tab 3
                    </h2>
                    <p className="mt-2 text-gray-700">
                      This is the section for Tab 3.
                    </p>
                  </div>
                )}
                {currentTab === "Obustave" && (
                  <div className="block w-full h-max rounded bg-white p-4 border-gray-300">
                    <h2 className="text-xl font-semibold text-gray-900">
                      Content for Tab 4
                    </h2>
                    <p className="mt-2 text-gray-700">
                      This is the section for Tab 4.
                    </p>
                  </div>
                )}
              </div>
            </div> */
}
//Tabovi

//Role html
{
  /* <div className="sm:col-span-1">
<label
  htmlFor="role"
  className="block text-sm font-medium leading-6 text-gray-900"
>
  Uloga
</label>
<div className="mt-1">

  <select
    disabled
    id="role"
    name="role"
    autoComplete="role"
    value={roles}
    onChange={onRolesChanged}
    className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:max-w-xs sm:text-sm sm:leading-6"
  >
    {options}
  </select>
</div>
</div> */
}
//Role html
